import { Expose, plainToClassFromExist, classToPlain } from 'class-transformer';

import { Default } from '@lib/common/decorators';

import { ISnLayoutNavbarConfig } from '../interfaces';
import { SnLayoutNavbarMode } from '../types';

export class SnLayoutNavbarConfig implements ISnLayoutNavbarConfig {
  @Expose()
  @Default('adaptive')
  public readonly mode: SnLayoutNavbarMode;

  @Expose()
  @Default(280)
  public readonly width: number;

  @Expose()
  @Default(false)
  public readonly collapsed: boolean;

  @Expose()
  @Default(false)
  public readonly hideCollapseButton: boolean;

  public readonly collapseWidth: number = 56;

  constructor(private readonly _defaultConfig: ISnLayoutNavbarConfig = {}) {
    this.restore();
  }

  public restore(): void {
    const config = { ...this._defaultConfig, collapsed: this.collapsed };
    plainToClassFromExist(this, config, { strategy: 'excludeAll' });
  }

  public update(config: ISnLayoutNavbarConfig): void {
    const currentConfig = classToPlain(this);
    plainToClassFromExist(this, { ...currentConfig, ...config }, { strategy: 'excludeAll' });
  }
}
